import { useEffect, useRef } from 'react';
import { trackReadingTime } from '@/lib/analytics';

/**
 * Tracks time spent on a page and fires a reading_time analytics event on unmount.
 * Ignores sub-2s bounces (handled by trackReadingTime).
 */
export function useReadingTime(pageId: string): void {
  const startRef = useRef<number>(Date.now());

  useEffect(() => {
    startRef.current = Date.now();
    return () => {
      trackReadingTime(pageId, Date.now() - startRef.current);
    };
  }, [pageId]);
}
